define(function(require) {

    return {
        TARGETS: [
            {
                LAYERS: ["Cs_Franco_2"],
                FILTERS: [
                    {
                        LAYER: "Unite_2008_1",
                        DATATABLE: "t_Unite_2008",
                        DATACOLUMN: "c_CD_CS_FRA"
                    }, {
                        LAYER: "Unite_2018",
                        DATATABLE: "t_Unites_de_peuplement_2018",
                        DATACOLUMN: "c_CD_CS_FRA"
                    }, {
                        LAYER: "Ecole_CSF_Prim_18",
                        DATATABLE: "t_Ecole_CSF_Prim_18",
                        DATACOLUMN: "c_CD_CS"
                    }, {
                        LAYER: "Ecole_CSF_Sec_18",
                        DATATABLE: "t_Ecoles_secondaires_francophones_2018",
                        DATACOLUMN: "c_CD_CS"
                    }
                ],
            }, {
                LAYERS: ["Cs_Anglo_2"],
                FILTERS: [
                    {
                        LAYER: "Unite_2008_1",
                        DATATABLE: "t_Unite_2008",
                        DATACOLUMN: "c_CD_CS_ANG"
                    }, {
                        LAYER: "Unite_2018",
                        DATATABLE: "t_Unites_de_peuplement_2018",
                        DATACOLUMN: "c_CD_CS_ANG"
                    }, {
                        LAYER: "Ecole_CSA_Prim_18",
                        DATATABLE: "t_Ecole_CSA_Prim_18",
                        DATACOLUMN: "c_CD_CS"
                    }, {
                        LAYER: "Ecole_CSA_Sec_18",
                        DATATABLE: "t_Ecole_CSA_Sec_18",
                        DATACOLUMN: "c_CD_CS"
                    }
                ],
            }, {
                LAYERS: ["Cs_Statut_2"],
                FILTERS: [
                    {
                        LAYER: "Unite_2008_1",
                        DATATABLE: "t_Unite_2008",
                        DATACOLUMN: "c_CD_CS_STA"
                    }, {
                        LAYER: "Unite_2018",
                        DATATABLE: "t_Unites_de_peuplement_2018",
                        DATACOLUMN: "c_CD_CS_STA"
                    }, {
                        LAYER: "Ecole_CSF_Prim_18",
                        DATATABLE: "t_Ecole_CSF_Prim_18",
                        DATACOLUMN: "c_CD_CS"
                    }, {
                        LAYER: "Ecole_CSF_Sec_18",
                        DATATABLE: "t_Ecoles_secondaires_francophones_2018",
                        DATACOLUMN: "c_CD_CS"
                    }, {
                        LAYER: "Ecole_CSA_Prim_18",
                        DATATABLE: "t_Ecole_CSA_Prim_18",
                        DATACOLUMN: "c_CD_CS"
                    }, {
                        LAYER: "Ecole_CSA_Sec_18",
                        DATATABLE: "t_Ecole_CSA_Sec_18",
                        DATACOLUMN: "c_CD_CS"
                    }
                ],
            }
        ]
    };
});
